import { Button, buttonVariants } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import { Link } from "@/navigation";
import { cn } from "@/lib/utils";

interface PricingTabProps {
  yearly: boolean;
  popular?: boolean;
  planName: string;
  cta: string;
  ctaLink: string;
  price: { monthly: number | string; yearly: number | string; isCustom?: boolean | undefined; }
  planDescription: string;
  //STRING OR NULL ARRAY
  features: (string | null)[];
}

export function PricingTab(props: PricingTabProps) {
  const t = useTranslations("pricing");
  return (
    <div className={`h-full`}>
      <div
        className={`relative flex flex-col h-full p-6 rounded-2xl border shadow shadow-slate-950/5 ${props.popular
            ? "bg-foreground border-slate-900"
            : "bg-background border-slate-200"
          }`}
      >
        {props.popular && (
          <div className="absolute top-0 right-0 mr-6 -mt-4">
            <div className="inline-flex items-center text-xs font-semibold py-1.5 px-3 bg-emerald-500 text-white rounded-full shadow-sm shadow-slate-950/5">
              {t("mostPopular")}
            </div>
          </div>
        )}
        <div className="mb-5">
          <div
            className={`${props.popular ? "text-slate-200" : "text-slate-900"
              } font-semibold mb-1`}
          >
            {props.planName}
          </div>
          <div className="inline-flex items-baseline mb-2">
            {!props.price.isCustom && (
            <span
              className={`${props.popular ? "text-slate-200" : "text-slate-900"
                } font-bold text-3xl`}
            >
              $
            </span>
            )}
            <span
              className={`${props.popular ? "text-slate-200" : "text-slate-900"
                } font-bold text-4xl`}
            >
              {
              !props.price.isCustom ?
              props.yearly ? props.price.yearly : props.price.monthly
              : props.price.yearly
              }
            </span>
            {!props.price.isCustom && <span
              className={`${props.popular ? "text-slate-400" : "text-slate-500"
                }  font-medium`}
            >
              /mo
            </span>}
          </div>
          <div
            className={`text-sm ${props.popular ? "text-slate-400" : "text-slate-500"
              } mb-5`}
          >
            {props.planDescription}
          </div>
          <Link href={props.ctaLink} className={cn(
          buttonVariants({ variant: "default" }),
          "w-full inline-flex justify-center whitespace-nowrap px-3.5 py-2.5 text-sm font-medium  transition-colors duration-150",
        )}>
            {/* {
            !props.price.isCustom ?
            "Get started"
            : "Contact sales"
            } */}
            {props.cta}
          </Link>
        </div>
        <div
          className={`${props.popular ? "text-slate-200" : "text-slate-900"
            } font-medium mb-3`}
        >
          {t("includes")}
        </div>
        <ul
          className={`${props.popular ? "text-slate-400" : "text-slate-600"
            } text-sm space-y-3 grow`}
        >
          {props.features.map((feature, index) => {
            return (
             feature && <li key={index} className="flex items-center">
                <svg
                  className="w-3 h-3 fill-emerald-500 mr-3 shrink-0"
                  viewBox="0 0 12 12"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M10.28 2.28L3.989 8.575 1.695 6.28A1 1 0 00.28 7.695l3 3a1 1 0 001.414 0l7-7A1 1 0 0010.28 2.28z" />
                </svg>
                <span>{feature}</span>
              </li>
            );
          })}
        
        </ul>
      </div>
    </div>
  );
}